class EnhancedVariantSwatches {
  constructor(container) {
    this.container = container;
    this.productId = container.dataset.productId;
    if (!container.dataset.productJson) {
        console.error('EnhancedVariantSwatches: Missing product JSON data on container for product ID:', this.productId);
        return; 
    }
    try {
        this.productData = JSON.parse(container.dataset.productJson);
    } catch (e) {
        console.error('EnhancedVariantSwatches: Invalid product JSON data for product ID:', this.productId, e);
        this.productData = null; 
        return;
    }
    
    this.currentVariantId = container.dataset.currentVariantId ? parseInt(container.dataset.currentVariantId, 10) : null;
    
    // Settings & Text
    this.moneyFormat = container.dataset.moneyFormat || '${{amount}}'; 
    this.oosBehavior = this.container.dataset.oosBehavior || 'disable';
    this.selectionIndicator = container.dataset.selectionIndicator || 'shadow'; 
    try { // Use try-catch for JSON.parse
        this.showSelectedValueText = JSON.parse(container.dataset.showSelectedValue || 'false');
    } catch(e) {
        this.showSelectedValueText = false;
    }


    this.textAddToCart = container.dataset.addToCartText || 'Add to Cart';
    this.textSoldOut = container.dataset.soldOutText || 'Sold Out';
    this.textUnavailable = container.dataset.unavailableText || 'Unavailable';
    this.textAdding = container.dataset.addingText || 'Adding...';
    this.textAdded = container.dataset.addedText || 'Added!';
    this.textError = container.dataset.errorText || 'Error';
    this.textInStock = container.dataset.inStockText || 'In Stock';
    this.textOutOfStock = container.dataset.outOfStockText || 'Out of Stock';


    // DOM Elements
    this.form = this.container.querySelector('form[data-type="add-to-cart-form"]');
    if (this.form) {
        this.variantIdInput = this.form.querySelector('.js-variant-id-input');
        this.submitButton = this.form.querySelector('button[type="submit"]');
        this.quantityInput = this.form.querySelector('input[name="quantity"]'); 
    }
    this.priceElement = this.container.querySelector('.js-product-price');
    this.skuElement = this.container.querySelector('.js-product-sku'); // Element holding the SKU value span
    this.skuElementWrapper = this.container.querySelector('.product__sku'); // The parent <p> tag for showing/hiding based on setting (handled by Liquid)
    this.availabilityElement = this.container.querySelector('.product__availability');
    this.mainProductImage = this.container.querySelector('.product__media-item img, .product-single__photo, .product__image-main img, img[data-main-product-image]'); // CRITICAL: ADJUST SELECTOR

    this.swatchFieldsets = this.container.querySelectorAll('.js-variant-option-fieldset');
    this.swatches = this.container.querySelectorAll('.js-swatch'); 
    this.selectedValueTextSpans = this.container.querySelectorAll('.js-selected-value-text');

    // Store indicator classes for easy removal
    this.indicatorClasses = [ 
        'selection-indicator--border', 'selection-indicator--shadow', 'selection-indicator--scale', 
        'selection-indicator--checkmark', 'selection-indicator--checkmark_border', 'selection-indicator--checkmark_shadow',
        'selection-indicator--border_scale', 'selection-indicator--shadow_scale' // Added new combo classes
    ];

    this.init();
  }

  init() {
    if(!this.productData || !this.productData.variants || this.productData.variants.length === 0) {
        if(this.submitButton) this.submitButton.disabled = true;
        return;
    }
    this.updateLinkedOptionStates(); // Run first to set initial disabled states
    this.onSwatchChange(); // Update based on initial selection
    // updateSelectedSwatchUI is called within onSwatchChange, so initial style is applied
    this.bindEvents();
  }


  bindEvents() {
    if (!this.swatches || this.swatches.length === 0) return; 

    this.swatches.forEach(swatchLabel => {
      swatchLabel.addEventListener('click', (event) => {
        const radioInput = document.getElementById(swatchLabel.getAttribute('for'));
        if (radioInput && !radioInput.disabled) {
            // Use setTimeout to allow radio 'checked' state update before processing
            setTimeout(() => {
                 this.onSwatchChange();
            }, 0);
        } 
      });
    });

    if (this.form) {
      this.form.addEventListener('submit', this.handleAddToCart.bind(this));
    }
  }

  onSwatchChange() {
    this.currentSelectedOptions = this.getSelectedOptions();
    const selectedVariant = this.findSelectedVariant();

    this.updateSelectedSwatchUI(); // Update visual selection class based on radio state
    this.updateLinkedOptionStates(); // Then update availability of OTHERS based on current selection

    if (this.showSelectedValueText) {
        this.updateSelectedValueText(); // Update text next to labels
    }

    if (selectedVariant) {
      this.currentVariantId = selectedVariant.id;
      if (this.variantIdInput) this.variantIdInput.value = selectedVariant.id;
      
      this.updateProductImage(selectedVariant);
      this.updatePrice(selectedVariant);
      this.updateSku(selectedVariant);
      this.updateSubmitButton(selectedVariant);
      this.updateAvailabilityText(selectedVariant);
    } else {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.textContent = this.textUnavailable;
      }
      if (this.variantIdInput) this.variantIdInput.value = '';
      // Clear dynamic info if no variant matches? Optional. Price/SKU might show last valid one.
      // if(this.priceElement) this.priceElement.innerHTML = ''; 
      // if(this.skuElement) this.skuElement.textContent = ''; 
      // if(this.availabilityElement) this.availabilityElement.textContent = '';
    }
  }

  updateSelectedSwatchUI() {
    // Remove selected class and ALL potential indicator classes from all swatch labels first
    this.swatches.forEach(label => {
        label.classList.remove('swatch--selected', ...this.indicatorClasses);
    });

    // Determine the indicator class to add based on the setting
    const indicatorClass = this.selectionIndicator !== 'none' ? `selection-indicator--${this.selectionIndicator}` : null;

    // Add selected class and the correct indicator class to the currently checked swatch label in each fieldset
    this.swatchFieldsets.forEach((fieldset) => {
        const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
            const label = this.container.querySelector(`label[for="${checkedInput.id}"]`);
            if (label) {
                label.classList.add('swatch--selected');
                if (indicatorClass && this.indicatorClasses.includes(indicatorClass)) {
                   label.classList.add(indicatorClass);
                }
            }
        }
    });
  }

  updateSelectedValueText() {
    this.selectedValueTextSpans.forEach(span => {
        const optionIndex = parseInt(span.dataset.optionIndex, 10);
        if (this.currentSelectedOptions[optionIndex]) {
            span.textContent = this.currentSelectedOptions[optionIndex];
        } else {
            span.textContent = ''; // Clear if no option selected
        }
    });
}


  getSelectedOptions() {
    const options = [];
    this.productData.options.forEach((optionInfo, index) => {
      const fieldset = this.container.querySelector(`.js-variant-option-fieldset[data-option-index="${index}"]`);
      let selectedValueForOption = null;
      if (fieldset) {
        const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
          selectedValueForOption = checkedInput.value;
        }
      }
      options[index] = selectedValueForOption;
    });
    return options;
  }
  
  findSelectedVariant() {
    if (this.currentSelectedOptions.some(optionValue => optionValue === null)) {
      return undefined; 
    }
    return this.productData.variants.find(variant => {
      return this.currentSelectedOptions.every((selectedOptionValue, optionIndex) => {
        return String(variant.options[optionIndex]) === String(selectedOptionValue);
      });
    });
  }

  updateProductImage(variant) {
    if (this.mainProductImage) {
        if (variant.featured_image && variant.featured_image.src) {
            this.mainProductImage.src = variant.featured_image.src;
            this.mainProductImage.alt = variant.featured_image.alt || variant.title;
            if (this.mainProductImage.hasAttribute('srcset') && variant.featured_image.srcset) {
                 this.mainProductImage.srcset = variant.featured_image.srcset;
            } else if (this.mainProductImage.hasAttribute('srcset')) { 
                this.mainProductImage.removeAttribute('srcset'); 
            }
        } else if (this.productData.featured_image && this.productData.featured_image.src) {
            this.mainProductImage.src = this.productData.featured_image.src;
            this.mainProductImage.alt = this.productData.featured_image.alt || this.productData.title;
            if (this.mainProductImage.hasAttribute('srcset') && this.productData.featured_image.srcset) {
                 this.mainProductImage.srcset = this.productData.featured_image.srcset;
            } else if (this.mainProductImage.hasAttribute('srcset')) {
                this.mainProductImage.removeAttribute('srcset');
            }
        }
    } else {
         // Only log warning once if image element isn't found
         if (!this.mainProductImageWarned) {
             console.warn('EnhancedVariantSwatches: Cannot update image - main product image element not found. Check selector in constructor.'); 
             this.mainProductImageWarned = true;
         }
    }
  }

  updatePrice(variant) {
    if (this.priceElement) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        this.priceElement.innerHTML = Shopify.formatMoney(variant.price, this.moneyFormat);
      } else {
        const formattedPrice = (variant.price / 100).toFixed(2);
        let template = this.moneyFormat.replace('{{amount}}', formattedPrice);
        template = template.replace('{{ amount }}', formattedPrice); 
        template = template.replace('{{amount_no_decimals}}', (variant.price / 100).toFixed(0));
        template = template.replace('{{ amount_no_decimals }}', (variant.price / 100).toFixed(0));
        this.priceElement.innerHTML = template;
      }
    }
  }

  updateSku(variant) {
    if (this.skuElement) {
      this.skuElement.textContent = variant.sku || '';
    }
  }

  updateSubmitButton(variant) {
    if (!this.submitButton) return;
    if (variant.available) {
      this.submitButton.disabled = false;
      this.submitButton.textContent = this.textAddToCart;
    } else {
      this.submitButton.disabled = true;
      this.submitButton.textContent = this.textSoldOut;
    }
  }

  updateAvailabilityText(variant) {
    if (this.availabilityElement) {
      this.availabilityElement.textContent = variant.available ? this.textInStock : this.textOutOfStock;
      if (variant.available) {
        this.availabilityElement.classList.remove('unavailable');
        this.availabilityElement.classList.add('available');
      } else {
        this.availabilityElement.classList.remove('available');
        this.availabilityElement.classList.add('unavailable');
      }
    }
  }

  updateLinkedOptionStates() {
    const currentSelections = this.getSelectedOptions(); 

    this.swatchFieldsets.forEach((fieldset, optionIndex) => {
      const currentOptionSwatches = fieldset.querySelectorAll('.js-swatch'); 

      currentOptionSwatches.forEach(swatchLabel => {
        const radioInput = document.getElementById(swatchLabel.getAttribute('for'));
        if (!radioInput) return;

        const value = radioInput.value;
        const swatchContainer = swatchLabel.closest('.swatch-container');

        // Reset states first
        swatchLabel.classList.remove('swatch--oos-disabled', 'swatch--oos-strikethrough');
        radioInput.disabled = false;
        if (swatchContainer) {
            swatchContainer.classList.remove('swatch--oos-hidden');
        }

        let isCurrentlySelectableAndAvailable = false;
        for (const variant of this.productData.variants) {
            let matchesPreviousAndCurrentValue = true;
            for (let i = 0; i < optionIndex; i++) {
                // Only consider previous selections that have been made
                if (currentSelections[i] !== null && currentSelections[i] !== variant.options[i]) {
                    matchesPreviousAndCurrentValue = false;
                    break;
                }
            }
            if (!matchesPreviousAndCurrentValue) continue; 

            // Check current option value match
            if (String(variant.options[optionIndex]) !== String(value)) {
                matchesPreviousAndCurrentValue = false;
            }

            // Check if this path leads to an available variant
            if (matchesPreviousAndCurrentValue && variant.available) {
                isCurrentlySelectableAndAvailable = true;
                break; 
            }
        }
        
        if (!isCurrentlySelectableAndAvailable) {
          switch (this.oosBehavior) {
            case 'hide':
              if (swatchContainer) swatchContainer.classList.add('swatch--oos-hidden');
              radioInput.disabled = true; 
              break;
            case 'strikethrough':
              swatchLabel.classList.add('swatch--oos-strikethrough');
              radioInput.disabled = true;
              break;
            case 'disable':
            default:
              swatchLabel.classList.add('swatch--oos-disabled');
              radioInput.disabled = true;
              break;
          }
        }
      });
    });
  }

  async handleAddToCart(event) {
    event.preventDefault();
    if (!this.variantIdInput || !this.submitButton || !this.form) return;

    const variantId = this.variantIdInput.value;
    const quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) : 1;

    if (!variantId) {
      console.error('EnhancedVariantSwatches: No variant selected for cart addition.');
      // Optionally display an error message to the user on the button or elsewhere
      this.submitButton.textContent = this.textUnavailable; // Re-use unavailable text?
      setTimeout(() => { // Reset button after showing message
          const currentVariant = this.findSelectedVariant();
          if(currentVariant && currentVariant.available) {
             this.submitButton.textContent = this.textAddToCart;
          } else if (currentVariant && !currentVariant.available) {
             this.submitButton.textContent = this.textSoldOut;
          } // else keep unavailable
      }, 1500);
      return;
    }
    if (isNaN(quantity) || quantity < 1) {
      console.error('EnhancedVariantSwatches: Invalid quantity.');
      // Add user feedback for invalid quantity if needed
      return;
    }

    this.submitButton.disabled = true;
    this.submitButton.textContent = this.textAdding;

    const formData = {
        'items': [{
            'id': variantId,
            'quantity': quantity
        }]
        // 'sections': 'cart-drawer,cart-icon-bubble', // Example sections for AJAX cart update
        // 'sections_url': window.location.pathname
    };
    
    try {
      const response = await fetch('/cart/add.js', { // Use Cart API endpoint directly
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(formData)
      });
      const cartData = await response.json();

      if (response.ok) {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cartData }));
        this.submitButton.textContent = this.textAdded;
        
        const currentSelectedVariant = this.findSelectedVariant();

        setTimeout(() => {
            if (currentSelectedVariant && currentSelectedVariant.available) {
                 this.submitButton.textContent = this.textAddToCart;
                 this.submitButton.disabled = false;
            } else {
                this.submitButton.textContent = (currentSelectedVariant && !currentSelectedVariant.available) ? this.textSoldOut : this.textUnavailable;
                this.submitButton.disabled = true;
            }
        }, 2000);

      } else {
        console.error('EnhancedVariantSwatches: Error adding to cart:', cartData.description || cartData.message || cartData);
        this.submitButton.textContent = this.textError;
        // Consider displaying cartData.message or cartData.description to the user
        this.submitButton.disabled = false; // Re-enable button on error
      }
    } catch (error) {
      console.error('EnhancedVariantSwatches: AJAX Add to Cart Error:', error);
      this.submitButton.textContent = this.textError;
      this.submitButton.disabled = false;
    }
  }

  static initializeAll() {
    document.querySelectorAll('.enhanced-variant-swatches').forEach(container => {
      if (container.dataset.initialized !== 'true') { 
        new EnhancedVariantSwatches(container);
        container.dataset.initialized = 'true';
      }
    });
  }
}

// Ensure initialization runs after DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', EnhancedVariantSwatches.initializeAll);
} else {
    EnhancedVariantSwatches.initializeAll(); 
}

// Re-initialize when sections are loaded or reloaded in Theme Editor
document.addEventListener('shopify:section:load', (event) => {
  if (event.target && typeof event.target.querySelectorAll === 'function') {
    event.target.querySelectorAll('.enhanced-variant-swatches').forEach(container => {
        if (container.matches('.enhanced-variant-swatches')) { 
            container.dataset.initialized = 'false'; 
            new EnhancedVariantSwatches(container);
        }
    });
  }
});